import { useState, useCallback, useEffect } from "react";

const defaultProps = {
  defaultHeight: 400,
};

export const useVerticalResizer = (defaultOptions = defaultProps) => {
  const [isResizing, setIsResizing] = useState(false);
  const [verticalHeight, setVerticalHeight] = useState(defaultOptions.defaultHeight);
  const [resizeStartPoint, setResizeStartPoint] = useState(0);

  const startResizing = useCallback((mouseEvent) => {
    setIsResizing(true);
    setResizeStartPoint(parseInt(mouseEvent.clientY));
  }, []);

  const stopResizing = useCallback(() => {
    setIsResizing(false);
    setResizeStartPoint(0);
  }, []);

  const resize = useCallback(
    (mouseEvent) => {
      if (isResizing && resizeStartPoint !== 0) {
        const resizedHeight = verticalHeight - -1 * (mouseEvent.clientY - resizeStartPoint);

        if (defaultOptions.minHeight && resizedHeight <= defaultOptions.minHeight) return;

        if (defaultOptions.maxHeight && resizedHeight >= defaultOptions.maxHeight) return;

        setVerticalHeight(verticalHeight - -1 * (mouseEvent.clientY - resizeStartPoint));
      }
    },
    [isResizing, defaultOptions.minHeight, defaultOptions.maxHeight]
  );

  useEffect(() => {
    window.addEventListener("mousemove", resize);
    window.addEventListener("mouseup", stopResizing);

    return () => {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    };
  }, [resize, stopResizing]);

  return {
    startResizing,
    verticalHeight,
    setVerticalHeight,
  };
};
